document.addEventListener("DOMContentLoaded", function () {

    if (window.innerWidth > 749) return;

    const paymentButton = document.querySelector('#buy-now-original');

    if (!paymentButton) return;

    const sticky = paymentButton.cloneNode(true);

    sticky.id = "sticky-buy-now";

    document.body.appendChild(sticky);

    Object.assign(sticky.style,{
        position:"fixed",
        left:"0",
        right:"0",
        bottom:"0",
        zIndex:"99999",
        background:"#fff",
        padding:"12px",
        boxShadow:"0 -3px 15px rgba(0,0,0,.15)",
        display:"none"
    });

    function updateVisibility(){

        const rect = paymentButton.getBoundingClientRect();

        if(rect.bottom < 0){
            sticky.style.display="block";
        }else{
            sticky.style.display="none";
        }

    }

    window.addEventListener("scroll",updateVisibility);

    updateVisibility();

});